import { render, staticRenderFns } from "./Base64AvatarUpload.vue?vue&type=template&id=619382aa&scoped=true&"
import script from "./Base64AvatarUpload.vue?vue&type=script&lang=ts&"
export * from "./Base64AvatarUpload.vue?vue&type=script&lang=ts&"
import style0 from "./Base64AvatarUpload.vue?vue&type=style&index=0&id=619382aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619382aa",
  null
  
)

export default component.exports